import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalReleaseNotesComponent } from './internal-release-notes.component';
import { InternalReleaseNotesService } from './internal-release-notes.service';
import { CxFormsModule } from '@forms';
import { UiFormatModule } from '@ui-format';

@NgModule({
    imports : [
        CommonModule,
        CxFormsModule,
        UiFormatModule,
    ],
    declarations : [
        InternalReleaseNotesComponent
    ],
    providers: [
        InternalReleaseNotesService
    ],
    exports : [
    ]
})
export class InternalReleaseNotesModule {

}

export {
    InternalReleaseNotesComponent
}
